import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthorizeDirective } from '@directives/authorize.directive';
import { CheckboxIExplorerHackDirective } from '@directives/checkbox-ie-hack.directive';
import { ClickTrackDirective } from '@directives/click-track.directive';
import { FolderAuthorizeDirective } from '@directives/folder-authorize.directive';
import {
    UiLegacyContextDirective,
    UiModernContextDirective,
} from '@directives/folder-context.directive';
import { FormGroupDirective } from '@directives/form-group.directive';
import { PreventAutofillDirective } from '@directives/prevent-autofill.directive';
import { UiRedrawOnLocaleChangeDirective } from '@directives/redraw-on-locale-change.directive';
import { RestrictInputDirective } from '@directives/restrict-input.directive';

const DIRECTIVES = [
    AuthorizeDirective,
    FolderAuthorizeDirective,
    RestrictInputDirective,
    FormGroupDirective,
    ClickTrackDirective,
    CheckboxIExplorerHackDirective,
    PreventAutofillDirective,
    UiRedrawOnLocaleChangeDirective,
    UiModernContextDirective,
    UiLegacyContextDirective,
];

@NgModule({
    imports: [CommonModule],
    declarations: DIRECTIVES,
    exports: DIRECTIVES,
})
export class DirectivesModule { }
